import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    ICompetencesPayload,
    ICompetencesSettingsPayload,
    IFilterCompetencesSettingsSlagState,
    IInitialStateCompetences,
} from "../types";
import { GetCompetences, GetCompetencesSettings, GetDeleteCompetencesSettings } from "./thunk";

const initialState: IInitialStateCompetences = {
    competences: [],
    competencesRestore: [],
    selectedCompetencesSettingsIDs: [],
    filterCompetencesSettingsSlag: [],
    competencesSettings: [],
    competencesSettingsRestore: [],
    isLoadingCompetences: false,
    isViewCompetencesRestore: false,
    isViewCompetencesSettingsRestore: false,
    selectedCompetencesIDs: [],
};

const competencesSlice = createSlice({
    name: "competences",
    initialState,
    reducers: {
        setCompetences: (state, action) => {
            state.competences = action.payload;
        },
        setCompetencesSettings(
            state,
            action: PayloadAction<{
                data: ICompetencesSettingsPayload[];
                defaultLanguage: string;
            }>
        ) {
            const { data, defaultLanguage } = action.payload;
            state.competencesSettings = data;
            state.filterCompetencesSettingsSlag = data
                .map(item => {
                    const translation = item.translations.find(trans => trans.slug === defaultLanguage);
                    if (translation) {
                        return {
                            id: item.id,
                            slug: translation.slug,
                            name: translation.name,
                            abbreviation: translation.abbreviation,
                        };
                    }
                    return null;
                })
                .filter((item): item is IFilterCompetencesSettingsSlagState => item !== null);
        },
        setIsViewRestoreCompetencesRestore: state => {
            state.isViewCompetencesRestore = !state.isViewCompetencesRestore;
        },
        setSelectedCompetencesSettingsIDs: (state, action) => {
            state.selectedCompetencesSettingsIDs = action.payload;
        },

        updateCompetences: (state, action: PayloadAction<ICompetencesPayload>) => {
            const updateData = action.payload;

            state.competences = state.competences.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        deletedCompetences: (state, action: PayloadAction<number>) => {
            state.competences = state.competences.filter(elem => elem.id !== action.payload);
        },
        deletedCompetencesSettings: (state, action: PayloadAction<number>) => {
            state.competencesSettings = state.competencesSettings.filter(elem => elem.id !== action.payload);
        },
        setCompetencesRestore: (state, action) => {
            state.competencesRestore = action.payload;
        },
        deletedRestoreCompetences: (state, action) => {
            state.competencesRestore = state.competencesRestore.filter(elem => elem.id !== action.payload);
        },
        setIsViewRestoreCompetencesSettingsRestore: state => {
            state.isViewCompetencesSettingsRestore = !state.isViewCompetencesSettingsRestore;
        },
        updateCompetencesSettings: (state, action: PayloadAction<ICompetencesSettingsPayload>) => {
            const updateData = action.payload;

            state.competencesSettings = state.competencesSettings.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setCompetencesSettingsRestore: (state, action) => {
            state.competencesSettingsRestore = action.payload;
        },
        deletedRestoreCompetencesSettings: (state, action) => {
            state.competencesSettingsRestore = state.competencesSettingsRestore.filter(
                elem => elem.id !== action.payload
            );
        },
        setSelectedCompetencesIDs: (state, action) => {
            state.selectedCompetencesIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetCompetences.pending, state => {
                state.isLoadingCompetences = true;
            })
            .addCase(GetCompetences.fulfilled, state => {
                state.isLoadingCompetences = false;
            })
            .addCase(GetCompetences.rejected, state => {
                state.isLoadingCompetences = false;
            })
            .addCase(GetCompetencesSettings.pending, state => {
                state.isLoadingCompetences = true;
            })
            .addCase(GetCompetencesSettings.fulfilled, state => {
                state.isLoadingCompetences = false;
            })
            .addCase(GetCompetencesSettings.rejected, state => {
                state.isLoadingCompetences = false;
            })
            .addCase(GetDeleteCompetencesSettings.pending, state => {
                state.isLoadingCompetences = true;
            })
            .addCase(GetDeleteCompetencesSettings.fulfilled, state => {
                state.isLoadingCompetences = false;
            })
            .addCase(GetDeleteCompetencesSettings.rejected, state => {
                state.isLoadingCompetences = false;
            });
    },
});

export const {
    setCompetences,
    setCompetencesSettings,
    setIsViewRestoreCompetencesRestore,
    updateCompetences,
    deletedCompetences,
    setCompetencesRestore,
    setSelectedCompetencesSettingsIDs,
    setIsViewRestoreCompetencesSettingsRestore,
    updateCompetencesSettings,
    deletedCompetencesSettings,
    deletedRestoreCompetences,
    setCompetencesSettingsRestore,
    deletedRestoreCompetencesSettings,
    setSelectedCompetencesIDs,
} = competencesSlice.actions;

export default competencesSlice;
